// extracted by mini-css-extract-plugin
export default {"toolBody":"ToolBody_toolBody__ml+So"};